import {LeadhubIdentify} from 'utils/leadhub';
import * as yup from "yup";
import useUser from "grandus-lib/hooks/useUser";
import useCart from "grandus-lib/hooks/useCart";
import { Form, Button, Row, Col, Checkbox } from "antd";
import { useFormikContext, Formik } from "formik";
import { get, first, isFunction } from "lodash";

import TextInput from "grandus-lib/components-atomic/form/TextInput";
import PasswordInput from "grandus-lib/components-atomic/form/PasswordInput";

import Link from "next/link";
import SalesManago from "utils/salesmanago";

const Login = ({ showRegister = true, afterLoginCallback = null }) => {
  const { mutateUser } = useUser();
  const { cart, mutateCart } = useCart();
  const formProps = {
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
      remember: false,
    },
    validationSchema: yup.object({
      email: yup
        .string()
        .nullable()
        .email("Zadajte email vo formáte name@domain.com")
        .required("Povinné pole"),
      password: yup.string().required("Povinné pole"),
      remember: yup.bool(),
    }),
    onSubmit: async (values, { errors, setFieldError, setErrors }) => {
      const { email, password } = values;
      const reqBody = { user: { email: email, password: password } };
      if (cart) {
        reqBody.cart = { accessToken: cart?.accessToken };
      }
      try {
        const user = await fetch(`/api/lib/v1/auth/signin`, {
          method: "POST",
          body: JSON.stringify(reqBody),
        }).then((response) => response.json());
        const message = get(first(user), "message");
        if (!message) {
          LeadhubIdentify(user,["login"])
          await mutateUser(user, false);
          if (user?.cart) {
            await mutateCart(get(user, "cart"), false);
          }
          SalesManago.contactUpsert({
            ...get(user, "attributes"),
            agreementAccepted: true,
          });
        } else {
          setFieldError("email", message);
          setFieldError("password", message);
        }

        if (isFunction(afterLoginCallback)) {
          afterLoginCallback(user);
        }
      } catch (error) {
        console.error("An unexpected error happened:", error);
        setErrors(error.data.message);
      }

      return false;
    },
  };

  return (
    <Formik {...formProps}>
      <LoginForm showRegister={showRegister} />
    </Formik>
  );
};

const LoginForm = ({ showRegister = true, showForgottenPassword = true }) => {
  const {
    values,
    errors,
    touched,
    isSubmitting,
    isValid,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormikContext();
  return (
    <Form wrapperCol={{ span: 24 }} layout="vertical" onFinish={handleSubmit}>
      <TextInput
        label="Email"
        name="email"
        values={values}
        touched={touched}
        errors={errors}
        handleChange={handleChange}
        handleBlur={handleBlur}
      />
      <PasswordInput
        label="Heslo"
        name="password"
        values={values}
        touched={touched}
        errors={errors}
        handleChange={handleChange}
        handleBlur={handleBlur}
      />
      <Form.Item>
        <Form.Item name="remember" valuePropName="checked" noStyle>
          <Checkbox>Zapamätať prihlásenie</Checkbox>
        </Form.Item>
        <Link href="/zabudnute-heslo" as="/zabudnute-heslo">
          <a className="login-form-forgot">Zabudnuté heslo</a>
        </Link>
      </Form.Item>
      <Form.Item>
        <Button
          style={{ marginRight: "10px" }}
          type="primary"
          htmlType="submit"
          loading={isValid && isSubmitting}
          disabled={!isValid}
        >
          Prihlásiť sa
        </Button>
        {showRegister ? (
          <>
            alebo sa{" "}
            <Link href="/registracia" as={`/registracia`}>
              <a>registrujte</a>
            </Link>
          </>
        ) : null}
      </Form.Item>
    </Form>
  );
};

export default Login;
